export const getInitials = (name: string | null | undefined): string => {
  if (!name) return "";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0].toUpperCase())
    .join("");
};
